import Joi from "joi";

export const JoiTranslatesScheme = Joi.object<{ en: string; ar: string }>({
  ar: Joi.string().allow("").required(),
  en: Joi.string().allow("").required(),
});
